import { NgModule } from '@angular/core';
import { FeatureFlagDirective } from './feature-flag.directive';
import { TextStyleDirective } from './text-style.directive';
import { ElementSpacingDirective } from './element-spacing.directive';


@NgModule({
  declarations: [
    ElementSpacingDirective,
    TextStyleDirective,
    FeatureFlagDirective
  ],
  exports: [
    ElementSpacingDirective,
    TextStyleDirective,
    FeatureFlagDirective
  ],
})
export class SharedDirectivesModule {
}
